var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBetaLabel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 6C23 4.89 22.021 4 20.8 4H3.2C1.979 4 1 4.89 1 6V18C1 19.11 1.979 20 3.2 20H20.8C22.021 20 23 19.11 23 18V6Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 6C23 4.89 22.021 4 20.8 4H3.2C1.979 4 1 4.89 1 6V18C1 19.11 1.979 20 3.2 20H20.8C22.021 20 23 19.11 23 18V6ZM6.72222 10.9444V9.88885C6.72222 9.51557 6.57396 9.15762 6.30998 8.89369C6.04605 8.62971 5.6881 8.48145 5.31481 8.48145H2.5V15.5185H5.31481C5.6881 15.5185 6.04605 15.3702 6.30998 15.1062C6.57396 14.8423 6.72222 14.4844 6.72222 14.1111V13.0555C6.72222 12.4926 6.22962 12 5.66667 12C6.22962 12 6.72222 11.5074 6.72222 10.9444ZM5.31481 14.1111H3.90741V12.7037H5.31481V14.1111ZM5.31481 11.2963H3.90741V9.88885H5.31481V11.2963ZM18.6852 8.48145C18.3119 8.48145 17.954 8.62971 17.69 8.89369C17.426 9.15762 17.2778 9.51557 17.2778 9.88885V15.5185H18.6852V12.7037H20.0926V15.5185H21.5V9.88885C21.5 9.51557 21.3517 9.15762 21.0878 8.89369C20.8238 8.62971 20.4659 8.48145 20.0926 8.48145H18.6852ZM18.6852 9.88885H20.0926V11.2963H18.6852V9.88885ZM12.3519 9.88885V8.48145H16.5741V9.88885H15.1667V15.5185H13.7593V9.88885H12.3519ZM7.42593 8.48145V15.5185H11.6481V14.1111H8.83333V12.7037H11.6481V11.2963H8.83333V9.88885H11.6481V8.48145H7.42593Z",
    fill: "#F64F31"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBetaLabel);
export default __webpack_public_path__ + "static/media/4bd9633957e6521bb3eee12c13bbbdb80d90679db3.svg";
export { ForwardRef as ReactComponent };